export class Lunch {
	constructor(obj) {
		if (!obj) return;

		this.paid = obj.paid;
		this.allowed = obj.allowed;
		this.period = obj.period;
	}
}

export default Lunch;
